import React from 'react'
import { Routes, Route } from "react-router";
import MultiStepForm from './pages/MultiStepForm';
import EditMultiStepForm from './pages/EditMultiStepForm';
import ActiveMeetings from './pages/ActiveMeetings';

const ZoomRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ActiveMeetings />} />
      <Route path="/create-meeting" element={<MultiStepForm />} />
      <Route path="/edit-meeting/:meetingId" element={<EditMultiStepForm />} />
      </Routes>
  )
}

export default ZoomRoutes